import { useInstamed } from "./instamed";
import { useStripe } from "./stripe";

export const providerNames = {
  stripe: "stripe",
  instamed: "instamed",
};

const availableProviders = {
  [providerNames.stripe]: useStripe,
  [providerNames.instamed]: useInstamed,
};

/**
 * Payment composable
 * The payment composable is a factory function that returns a payment composable based on the provider.
 *
 * @param {Object} config
 * @param {String} config.provider - the payment provider name
 * @param {String} config.publishableKey - api key
 *
 * @throws {Error} - If provider is not supported
 * @returns {Object} - The payment composable
 * @property {import("vue").Ref<String>} paymentType - The payment type
 * @property {Function} createAndMountElement - Creates and mounts the payment element
 * @property {Function} validatePayment - Validates the payment
 * @property {Function} confirmPayment - Confirms the payment
 */
export function usePayment(host, config) {
  const provider = availableProviders[config.provider];

  if (!provider) {
    throw new Error(`Unsupported payment provider: ${config.provider}`);
  }

  return provider(host, config);
}
